import './tableData.scss'
import {useEffect, useState} from "react";
import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
} from '@chakra-ui/react'
import {formatDataItalianoConOra} from "../../utilities/formatDate";

const TableData = ({actualStep, data, filter}) => {
    const [filteredData, setFilteredData] = useState(data);

    useEffect(() => {
        if (!data && !filter && !actualStep) return;

        let processedData = [...data]; // Copia array per non mutare l'originale

        // Ordina per timestamp decrescente (più recenti in cima)
        processedData.sort((a, b) => {
            const dateA = new Date(a.ts_event);
            const dateB = new Date(b.ts_event);
            return dateB - dateA; // Ordine decrescente
        });

        // Applica filtro se presente
        if (!filter) {
            setFilteredData(processedData);
            return;
        }

        if (actualStep !== 0) {
            setFilteredData(processedData.filter(row =>
                row.security.toLowerCase() === filter.toLowerCase()
            ));
        } else {
            setFilteredData(processedData.filter(row =>
                row.msg.toLowerCase().includes(filter.toLowerCase())
            ));
        }
    }, [actualStep, data, filter]);

    return (
        <TableContainer>
            <Table variant='simple' className="table">
                {actualStep === 0 && <TableCaption>Selected Securities by Gap Percentage</TableCaption>}
                {actualStep === 1 && <TableCaption>Securities Passed First Bar</TableCaption>}
                {actualStep === 2 && <TableCaption>Securities Passed Second Bar</TableCaption>}
                {actualStep === 3 && <TableCaption>Let the trade Begin </TableCaption>}

                <Thead>
                    <Tr>
                        {data && data[0]['security'] ? (
                            <Th>Security</Th>
                        ) : ''}
                        <Th>Logs</Th>
                        <Th>Severity</Th>
                        <Th>Strategy</Th>
                        <Th>Data</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {filteredData?.map((row, index) => (
                        <Tr key={index}>
                            {row?.security ? (
                                <Td>{row.security}</Td>
                            ) : ''}
                            <Td whiteSpace="normal" wordBreak="break-word">{row.msg}</Td>
                            <Td>{row.severity}</Td>
                            <Td>{row.strategy}</Td>
                            <Td>{formatDataItalianoConOra(row.ts_event)}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    );
}

export default TableData;